const INTEGER_STRING = /^-?\d+$/;

/**
 * 给 `parseSearchWith` 用的解析器：整数 query 保持字符串，其余走 JSON.parse。
 *
 * TSR 默认 `JSON.parse("217317097930443777")` 会先收成 Number，超过
 * `Number.MAX_SAFE_INTEGER` 后精度丢失，`asSearchString` 无法再还原。
 */
export function parseSearchValue(value: string): unknown {
  if (INTEGER_STRING.test(value)) return value;
  return JSON.parse(value);
}

/**
 * 把 TSR search 值收成 string。
 * 整数 query 应由 `parseSearchValue` 保持为 string；这里仍兼容 number，
 * 但已丢精度的大整数无法还原。
 *
 * 配合 `stringifySearchWith(JSON.stringify)`，写出时不会给数字字符串加引号。
 */
export function asSearchString(value: unknown): string | undefined {
  if (typeof value === "string") return value;
  if (typeof value === "number" && Number.isFinite(value)) return String(value);
  return undefined;
}

const SAFE_INTEGER_MIN = BigInt(Number.MIN_SAFE_INTEGER);
const SAFE_INTEGER_MAX = BigInt(Number.MAX_SAFE_INTEGER);

/**
 * 给 `parseSearchWith` 用的 JSON.parse 替代品。
 * 超过 Number 安全整数范围的整数字面量（如雪花 ID）保持为 string，避免丢精度。
 *
 * @example
 * createRouter({
 *   parseSearch: parseSearchWith(parseSearchJson),
 *   stringifySearch: stringifySearchWith(JSON.stringify),
 * })
 */
export function parseSearchJson(value: string): unknown {
  if (/^-?\d+$/.test(value)) {
    try {
      const n = BigInt(value);
      if (n > SAFE_INTEGER_MAX || n < SAFE_INTEGER_MIN) {
        return value;
      }
    } catch {
      // 非法整数字面量（如前导 0）走 JSON.parse
    }
  }
  return JSON.parse(value);
}
